import { publicDataFetch } from '../api';

function buildQuery(query = {}) {
  const params = new URLSearchParams({ limit: 1000, ...query });
  return params.toString();
}

async function request(path, options = {}) {
  const response = await publicDataFetch(path, options);

  if (response?.status !== 'success') {
    throw new Error(response?.error || `${options.method || 'GET'} ${path} failed`);
  }

  return response;
}

export const api = {
  get(collection, query = {}) {
    return request(`read/${collection}?${buildQuery(query)}`);
  },

  post(collection, data) {
    return request(`create/${collection}`, {
      method: 'POST',
      body: JSON.stringify(data)
    });
  },

  put(collection, id, data) {
    return request(`update/${collection}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  },

  delete(collection, id) {
    return request(`delete/${collection}/${id}`, {
      method: 'DELETE'
    });
  }
};